import React from "react";
import { inpS, sp } from "../../constants/styles";

const Fld = ({ l, v, set, h, type, ph }) => <>
  <label style={{ color: h.ts || h.sc, fontSize: 12, fontWeight: 600, display: "block", marginBottom: sp.xs + 1, letterSpacing: "0.3px", textTransform: "uppercase" }}>{l}</label>
  <input value={v} onChange={e => set(e.target.value)} type={type || "text"} placeholder={ph || ""} style={inpS(h)} />
</>;

export default Fld;
